import styled from 'styled-components';

export const LinkWrapper = styled.div`
  display: inline-flex;
  gap: 8px;
`;
